import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, ArticleHeading2, Image } from '@cian/ui-kit';

import { IFeatureCardProps } from './types';
import { IMAGE_SIZE } from './constants';
import { withDeviceType } from '../../utils/withDeviceType';
import { ArrowRight } from '../ArrowRight';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../constants/mediaQueries';

import * as styles from './styles.css';

/**
 * Список крупных карточек с круглым изображением и текстовой информацией.
 */
const FeatureCard: React.FC<React.PropsWithChildren<IFeatureCardProps>> = ({
  title,
  description,
  image,
  gradient,
  buttonText,
  onButtonClick,
  theme,
  deviceType,
  isPhone,
}) => {
  const imageSize = IMAGE_SIZE[deviceType];
  const Heading = isPhone ? ArticleHeading2 : ArticleHeading1;
  const headingColor = theme === 'light' ? 'white_100' : 'black_100';

  return (
    <section className={cn(styles['card'], styles[deviceType])}>
      <div className={cn(styles['image'], styles[`theme-${theme}`], styles[`gradient-${gradient}`])}>
        <Image
          width={imageSize}
          height={imageSize}
          borderRadius="50%"
          sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: image.x2 }, { srcset: image.x1 }]}
          src={image.x1}
          loading="lazy"
        />
      </div>
      <Heading as="h3" color={headingColor}>
        {title}
      </Heading>
      <div className={cn(styles['description'], styles[deviceType], styles[`theme-${theme}`])}>{description}</div>
      <button
        type="button"
        className={cn(styles['button'], styles[`theme-${theme}`])}
        data-testid="feature-button"
        onClick={onButtonClick}
      >
        {buttonText}
        <span className={styles['icon']} aria-hidden>
          <ArrowRight />
        </span>
      </button>
    </section>
  );
};

const FeatureCardWithDeviceType = withDeviceType(FeatureCard);
export { FeatureCardWithDeviceType as FeatureCard };
